var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.25C7.0335 6.25 6.25 7.0335 6.25 8V18C6.25 18.9665 7.0335 19.75 8 19.75H20C20.9665 19.75 21.75 18.9665 21.75 18V12.4142C21.75 11.9501 21.5656 11.505 21.2374 11.1768L16.8232 6.76256C16.495 6.43437 16.0499 6.25 15.5858 6.25H8ZM7.75 8C7.75 7.86193 7.86193 7.75 8 7.75H15.25V11C15.25 11.9665 16.0335 12.75 17 12.75H20.25V18C20.25 18.1381 20.1381 18.25 20 18.25H8C7.86193 18.25 7.75 18.1381 7.75 18V8Z",
    fill: "#050022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19V22",
    stroke: "#050022",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2938 25.1819C14.1355 25.3534 13.8645 25.3534 13.7062 25.1819L11.1561 22.4214C10.9195 22.1652 11.1012 21.75 11.45 21.75L16.55 21.75C16.8988 21.75 17.0805 22.1652 16.8439 22.4214L14.2938 25.1819Z",
    fill: "#050022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.5e5e69518ceea0ce9bc8d00f627c8964.svg";
export { ForwardRef as ReactComponent };